export default {
    path: '/modules/accounts',
    component: () => import('@/modules/accounts/pages/index.vue'),
    children: [
        {
            path: 'add/:user_id?',
            component: () => import('@/modules/accounts/pages/edit.vue'),
            meta: {
                pageTitle: '添加/修改账户',
                parent: '/modules/accounts/list',
            }
        },
        {
            path: 'list',
            component: () => import('@/modules/accounts/pages/list.vue'),
            meta: {
                pageTitle: '账户列表',
            }
        },
        {
            path: 'taskList',
            component: () => import('@/modules/accounts/pages/taskList.vue'),
            meta: {
                pageTitle: '任务管理',
            }
        },
        {
            path: 'taskLogs',
            component: () => import('@/modules/accounts/pages/taskLogs.vue'),
            meta: {
                pageTitle: '任务日志',
            }
        },
        {
            path: 'management',
            component: () => import('@/modules/accounts/pages/management.vue'),
            meta: {
                pageTitle: '组织架构管理'
            }
        },{
            path: 'accountmanagement',
            component: () => import('@/modules/accounts/pages/accountmanagement.vue'),
            meta: {
                pageTitle: '账号管理'
            }
        },{
            path: 'jurisdiction',
            component: () => import('@/modules/accounts/pages/jurisdiction.vue'),
            meta: {
                pageTitle: '角色权限管理'
            }
        },{
            path: 'assignment',
            component: () => import('@/modules/accounts/pages/assignment.vue'),
            meta: {
                pageTitle: '人员权限管理'
            }
        },{
            path: 'configuration',
            component: () => import('@/modules/accounts/pages/configuration.vue'),
            meta: {
                pageTitle: '权限配置管理'
            }
        },{
            path: 'Menumanagement',
            component: () => import('@/modules/accounts/pages/Menumanagement.vue'),
            meta: {
                pageTitle: '菜单管理'
            }
        },
    ]
};
